const __WEBPACK_NAMESPACE_OBJECT__ = require("@tanstack/react-query");